import styled from 'styled-components'

export const Container = styled.div`
    position: absolute;
    top: 50vh;
    left: 50vw;
    transform: translate(-50%, -50%);
    background-color: #fff;
    border-radius: 1vw;
    z-index: 1;
`

export const HeaderDiv = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 57vw;
    margin-top: 2.8vh;
    margin-left: 1.5vw;
    margin-right: 1vw;
`

export const HeaderText = styled.h2`
    font-family: 'Inter', sans-serif;
    font-size: 1.4vw;
    font-weight: 700;
    margin-top: 0;
    margin-bottom: 0;
`

export const CloseDiv = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 2vw;
    cursor: pointer;
    width: 2.5vw;
    height: 2.5vw;

    :hover{
        background-color: #F4F4F4;
    }
`

export const CloseImg = styled.img`
    width: 0.8vw;
`

export const ProgressBarDiv = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 2.8vh;
    margin-left: 0.1vw;
    margin-right: 0.1vw;

    .active{
        background-color: #0090D3;
    }
`

export const ProgressBarCircle = styled.div`
    width: 1vw;
    height: 1vw;
    border-radius: 2vw;
    background-color: #C4C4C4;
`

export const ProgressBarLine = styled.div`
    width: 27vw;
    height: 0.5vh;
    background-color: #C4C4C4;
`

export const InputRowDiv = styled.div`
    display: flex;
    width: 57vw;
    margin-top: 2.5vh;
    margin-left: 1.5vw;
    justify-content: space-between;
`

export const InputDiv = styled.div`
    position: relative;

    .redBorder {
        border: #FF0000 1px solid;
    }

    .empty {
        border: 0;
    }
`

export const InputLabel = styled.label`
    display: block;
    font-family: 'Inter', sans-serif;
    font-weight: 700;
    font-size: 0.9vw;
`

export const Input = styled.input`
    width: 15.5vw;
    height: 5.3vh;
    background-color: #EBEBEB;
    border: 0;
    border-radius: 2vw;
    margin-top: 0.8vh;
    padding-left: 1vw;
    padding-right: 1vw;

    :focus {
        outline: 0;
    }
`

export const ButtonsDiv = styled.div`
    display: flex;
    position: relative;
    align-items: center;
    margin-left: 41.5vw;
    justify-content:end;
    padding-right:1vw;
`

export const WarningDiv = styled.div`
    position: absolute;
    display: flex;
    width: 30vw;
    justify-content: end;
    right: 1.5vw;
    bottom: 7.5vh;
`

export const WarningText = styled.p`
    font-family: 'Inter', sans-serif;
    font-size: 0.8vw;
    color: #FF0000;
`

export const CancelButton = styled.button`
    width: 8vw;
    height: 5.8vh;
    background-color: #fff;
    color: #0090D3;
    font-family: 'Inter', sans-serif;
    font-size: 1vw;
    font-weight: 700;
    margin-top: 2.5vh;
    margin-bottom: 2.5vh;
    border: 1px #0090D3 solid;
    border-radius: 3vw;
    cursor: pointer;
`

export const PreviousButtonDiv = styled.div`
    display: flex;
    align-items: center;
    width: 6.5vw;
    height: 5.8vh;
    background-color: #fff;
    color: #0090D3;
    border: solid #0090D3 1px;
    margin-top: 2.5vh;
    margin-bottom: 2.5vh;
    margin-left: 1vw;
    border-radius: 3vw;
    cursor: pointer;
`

export const PreviousButtonImage = styled.img`
    margin-left: 1vw;   
    width: 0.9vw;
`

export const PreviousButtonText = styled.p`
    font-family: 'Inter', sans-serif;
    font-size: 1vw;
    font-weight: 700;
    margin-left: 0.6vw;
`

export const NextButtonDiv = styled.div`
    display: flex;
    align-items: center;
    width: 8vw;
    height: 5.8vh;
    background-color: #0090D3;
    color: #fff;
    margin-top: 2.5vh;
    margin-bottom: 2.5vh;
    margin-left: 1vw;
    border-radius: 3vw;
    cursor: pointer;
    // pointer-events: none;

    .disable {
        opacity: 0.5;
        poiter-events: not-allowed;
    }
`

export const NextButtonImage = styled.img`
    margin-left: 1vw;   
    width: 0.9vw;
`

export const NextButtonText = styled.p`
    font-family: 'Inter', sans-serif;
    font-size: 1vw;
    font-weight: 700;
    margin-left: 0.6vw;
`
